import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import {
  getStoredUserTimeZone,
  persistUserTimeZone,
  resolveTimeZoneOption,
  USER_TIMEZONE_UPDATED_EVENT,
} from '../utils/timezone';

const TimezoneContext = createContext(null);

export function TimezoneProvider({ children }) {
  const [timeZone, setTimeZoneState] = useState(() => getStoredUserTimeZone());

  const setTimeZone = (nextTimeZone) => {
    const normalized = persistUserTimeZone(nextTimeZone);
    setTimeZoneState(normalized);
  };

  useEffect(() => {
    const syncTimeZone = (event) => {
      const next = resolveTimeZoneOption(
        event?.detail?.time_zone,
        getStoredUserTimeZone()
      );
      setTimeZoneState(next);
    };

    window.addEventListener(USER_TIMEZONE_UPDATED_EVENT, syncTimeZone);
    return () => window.removeEventListener(USER_TIMEZONE_UPDATED_EVENT, syncTimeZone);
  }, []);

  const value = useMemo(
    () => ({
      timeZone,
      setTimeZone,
    }),
    [timeZone]
  );

  return <TimezoneContext.Provider value={value}>{children}</TimezoneContext.Provider>;
}

export function useTimezone() {
  const context = useContext(TimezoneContext);
  if (!context) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
}
